<template>
  <div class="globalErrorModalComponent">
    <!-- ERROR MODAL -->
    <b-modal v-model="isGlobalErrorModal" size="lg" id="globalAPILoadingErrorModal" hide-footer :title="$t('global_error_modal.title')">
      <div class="text-center">
        <p>
          {{ $t('global_error_modal.message') }}
        </p>
        <b-button class="mt-3" variant="outline-dark" @click="$store.commit('closeGlobalErrorModal')">
          {{ $t('global_error_modal.close') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'globalErrorModalComponent',
  computed : {
    isGlobalErrorModal: {
      get () {
        return this.$store.state.isGlobalErrorModal
      },
      set () {
        this.$store.commit('closeGlobalErrorModal')
      }
    },
  }
}
</script>
